import { useChainId, useBalance } from 'wagmi'
import { NetworkId } from '@/types/network'
import { getCEXFundBalanceAddress } from '@/config/get-cex-fund-address'

export function useCEXFundEthBalance() {
	const chainId = useChainId()

	const cexFundAddress = getCEXFundBalanceAddress(chainId as NetworkId)

	return useBalance({
		address: cexFundAddress
	})
}
